define(["backbone", "configuration/properties"], function (Backbone) {
  var NotificationModel = {};
  NotificationModel.model = Backbone.Model.extend({
    idAttribute: "id",
    defaults: {
      userId: 0,
      notificationIdentifier: "",
      preventEmail: false,
    },
  });

  NotificationModel.collection = Backbone.AtomicCollection.extend({
    model: NotificationModel.model,
  });

  return NotificationModel;
});
